import { render, staticRenderFns } from "./UnitsListPopup.vue?vue&type=template&id=549bd50c&"
import script from "./UnitsListPopup.vue?vue&type=script&lang=js&"
export * from "./UnitsListPopup.vue?vue&type=script&lang=js&"
import style0 from "./UnitsListPopup.vue?vue&type=style&index=0&id=549bd50c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports